var _defs, _path, _path2, _path3, _line, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRighttowork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.36,171.07h47.28a9,9,0,0,0,9-9v-20.5a9,9,0,0,0-9-9H104.36a9,9,0,0,0-9,9v20.5A9,9,0,0,0,104.36,171.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232,58.27H24a6,6,0,0,0-6,6v81.54a6,6,0,0,0,6,6H95.36V141.57a9,9,0,0,1,9-9h47.28a9,9,0,0,1,9,9v10.25H232a6,6,0,0,0,6-6V64.28A6,6,0,0,0,232,58.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.64,162.07a9,9,0,0,1-9,9H104.36a9,9,0,0,1-9-9V151.82H24.75v84.49h206.5V151.82H160.64Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.33,
    y1: 92.94,
    x2: 151.67,
    y2: 92.94
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.85,102.66V80.47a6,6,0,0,1,6-6h9.52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.15,57V34.7a15,15,0,0,0-15-15H96.86a15,15,0,0,0-15,15V57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighttowork);
export default __webpack_public_path__ + "static/media/righttowork.f89d4bfafb4f2740dec51fd67c7e9754.svg";
export { ForwardRef as ReactComponent };